import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    string = PropTypes.string;
ModalBody.propTypes = {
  children: node,
  className: string
};
/**
 * Default props
 */

ModalBody.defaultProps = {
  children: null,
  className: ''
};
export default styled(ModalBody).withConfig({
  displayName: "Body",
  componentId: "sc-1oplq0s-0"
})(["width:100%;height:auto;flex:1;margin:", ";"], function (_ref2) {
  var center = _ref2.center;
  return center ? 'auto' : 'initial';
});